/* eslint-disable no-unused-expressions */
import React, { Component } from "react";
import theme from "../../../../assests";
import {
  MuiTypography,
  MuiInput,
  MuiInputLabel,
  MuiButton,
  muiWithStyles,
  MuiTextField,
  MuiGrid,
  MuiCheckbox
} from "../../../ui";
import MaterialUIForm from "material-ui-form";
import PropTypes from "prop-types";
import { NewPasswordRequired } from "react-cognito";
import PageContainer from "../../../ui/PageContainer";
import withAppShell from '../../../hoc/withAppShell/WithAppShell';
import { connect } from 'react-redux'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
import lodashUtil from 'lodash'
import * as systemConfig from '../../../../../src/systemConfig.json';
class NewPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      message: "",
      isTcAccepted: false
    };
  }


  componentWillMount() {
    let i18n;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    this.setState({
      i18n: i18n
    })
  }
  handleCheck = (event) => {
    this.setState({ isTcAccepted: event.target.checked })
  }
  validate = () => {
    if (this.state.newPassword === "") {
      this.setState({ message: "Please fill in new password field" });
    }
    if (this.state.newPassword.length < 8) {
      this.setState({ message: "Password should be of min length 8" });
    }
    if (this.state.newPassword === this.state.confirmPassword) {
      return true;
    }
    if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({ message: "Passwords do not match" });
      return false;
    }
  };
  onSubmit = event => {
    if (this.validate()) {
      this.props.onSubmit(this.state.newPassword)
        .then(() => this.setState({

        }),

      )
        .catch((err) => {
          this.setState({
            message: err.message
          });
        })
    }
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value, message: "" });
  };
  render() {
    const { i18n } = this.state
    return (
      <div style={{ display: "flex", width: "90%", flexDirection: "column" }}>
        <MuiTypography variant={theme.typographyStyles.H4} style={theme.gridHeaderTextStyle}>
          New Password Setup
        </MuiTypography>
        <MaterialUIForm
          className="ChangePasswordForm"
          onSubmit={() => {
            this.onSubmit();
          }}
        >
          <MuiTypography variant={theme.typographyStyles.TITLE} />
          <MuiTextField
            required
            id="newPassword"
            type="password"
            label="New Password"
            data-validators="isRequired"
            onChange={this.handleChange("newPassword")}
            style={theme.muiTextFieldStyleForMainScreen}
          />
          <MuiTextField
            required
            id="confirmPassword"
            type="password"
            label="Re-enter your password"
            data-validators="isRequired"
            onChange={this.handleChange("confirmPassword")}
            style={theme.muiTextFieldStyleForMainScreen}
          />
          <br />
          <MuiGrid>
            <MuiTypography variant="caption" color="error">
              {this.state.message}
            </MuiTypography>
          </MuiGrid>
          <br />
          <MuiGrid container alignItems="flex-start">
            <MuiCheckbox color="primary" alignItems="flex-start" onChange={(event) => this.handleCheck(event)} checked={this.state.isTcAccepted} />
            <MuiGrid item container direction="column" justify="center" xs alignItems="flex-start">
              <MuiGrid><MuiTypography variant={theme.typographyStyles.body2} color='primary'>I have read the <a href={systemConfig.termsAndConditionsURL} target="_blank">

                Privacy Policy

            </a></MuiTypography></MuiGrid>
              <MuiGrid><MuiTypography variant={theme.typographyStyles.body2} color='primary'>I agree to the <a href={systemConfig.termsAndConditionsURL} target="_blank">Terms and Conditions</a></MuiTypography></MuiGrid>
            </MuiGrid>
          </MuiGrid>
          <br />
          <br />
          {this.state.isTcAccepted ?<MuiButton
            id="confirm"
            style={theme.primaryButtonStyle}
            type="submit"
            disabled
          >
            Confirm
          </MuiButton>:<MuiButton disabled style={theme.primaryButtonDisabledStyle}>
          Confirm
</MuiButton>}
          
        </MaterialUIForm>
        <MuiTypography variant="caption" color="primary">{i18n.resetPassword.minmumPasswordLength}</MuiTypography>
      </div>
    );
  }
}
NewPasswordForm.propTypes = {
  state: PropTypes.string,
  onSubmit: PropTypes.func
};

const NewPasswordComponent = () => (
  <PageContainer>
    <NewPasswordRequired>
      <NewPasswordForm />
    </NewPasswordRequired>
  </PageContainer>
);
const componentStyle = theme => ({
  pageStyle: {
    padding: 100,
    border: "1px solid red"
  }
});

const mapStateToProps = (state) => {
  return {
    i18n: state.i18nMessages.i18n
  }
}
export default withAppShell((muiWithStyles(componentStyle), connect(mapStateToProps)(NewPasswordComponent)), { properties: { isProtected: false } });
